<template>
    <div>
        <v-layout wrap justify-center align-center mb-3 class="contenidoCurso">
            <v-flex xs11 sm10 md9>
                <h1>Glosario</h1>
            </v-flex>
            <!-- contenido -->
            <v-flex xs11 sm10 md9 mb-2>
                <v-layout wrap row v-for="(gr, idx) in grupo" :key="idx">
                    <v-flex xs12 :class="{'marginTop':idx!=0}">
                        <h2>{{gr}}</h2>
                    </v-flex>
                    <v-flex 
                            v-for="(item,i) in Object.keys(glosario)" :key="i"
                            class="glosario-definiciones"
                            v-if="glosario[item].grupo == gr"
                        >
                        <v-layout wrap row justify-center>
                            <v-flex xs6 sm3 md2 mt-3>
                                <img :src="require(`../assets/imagenes_compartidas/glosario/glosaio-${glosario[item].imagen}.png`)" alt="">
                            </v-flex>
                            <v-flex xs12>
                                <div slot="header"><h3><span  class="termino">{{item}}</span></h3></div>
                            </v-flex>
                            <v-flex xs12> 
                                <p class="definicion" v-html="glosario[item].concepto"></p>
                            </v-flex>
                        </v-layout>
                        
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import resourcesLoader from "../js/mixins/resources-loader";
    export default {
        data() {
            return {
                glosario: {},
                palabras:[],
                grupo:[]
            }
        },
        created() {
            let final = []
            this.glosario = require('@/assets/glosario.json')
            this.palabras = Object.keys(this.glosario).sort()
            this.palabras.map(el => final.push(el[0]))
            this.grupo = final.filter((valor, indiceActual, arreglo) => arreglo.indexOf(valor) === indiceActual);
            //console.log(this.grupo)
        }
    }
</script>
<style lang="scss" scoped>
@import '../sass/globals';
    .termino {
        font-weight: bold;
    }
    h1 {
        text-align: left;
        //margin-bottom: 1.8rem;
        font-family: FontBase-Bold;
        color: $color-primary;
    }
    h3{
        text-align: left;
        font-family: FontBase-SemiBold;
        color: $color-primary;
    }
    h2{
        text-align: left;
        font-size: 3rem;
        font-family: FontBase-LightItalic;
        color: $color-secondary;
    }
    .glosario-definiciones{
        border-bottom: 2px solid sandybrown;
    }
    .definicion{
        margin-bottom: 5px;
    }
    .marginTop{
        margin-top: 48px !important;
    }
</style>